import React from "react";
import Page from "../templates/conserve/conservepage";
import { Helmet } from "react-helmet";

export default function home() {
  return (
    <div>
      <Helmet>
        <title>
          Environmental Conservation | Sustainable Practices | Hirdaramani
        </title>
        <meta
          name="title"
          content="Environmental Conservation | Sustainable Practices | Hirdaramani"
        />
        <meta
          name="description"
          content="Explore our commitment to environmental conservation. From reducing carbon footprint to conservation efforts, see how we lead the apparel industry in sustainability."
        />
        <link
          rel="canonical"
          href="https://sustainability.hirdaramani.com/conserve/"
        />
        <meta property="og:locale" content="en_US" />
        <meta name="keywords" content="Environmental Conservation" />
        <meta
          property="og:title"
          content="Environmental Conservation | Sustainable Practices | Hirdaramani"
        />
        <meta
          property="og:description"
          content="Explore our commitment to environmental conservation. From reducing carbon footprint to conservation efforts, see how we lead the apparel industry in sustainability."
        />
        <meta
          property="og:image"
          content="https://hirdaramani-microsite.sgp1.digitaloceanspaces.com/images/logo.png"
        />
        <meta
          property="og:url"
          content="https://sustainability.hirdaramani.com/conserve/"
        />
      </Helmet>

      <Page />
    </div>
  );
}
